<template>
  <b-card>
    <b-form @submit="addPodcast">
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <template #label>
              Title <span class="text-danger">*</span>
            </template>
            <b-form-input id="title" v-model="form.title" placeholder="Ex. HSI with OCS" required />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group>
            <template #label>
              YouTube Link <span class="text-danger">*</span>
            </template>
            <b-form-input
              id="youtubeLink"
              v-model="form.youtubeLink"
              required
              placeholder="Ex. https://youtu.be/SBzMjqFhgJ8?si=0p9RNom07aSKLtz4"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group>
            <template #label>
              Label <span class="text-danger">*</span>
            </template>
            <Select2
              id="label_name"
              v-model="form.label_name"
              multiple
              :options="labelNameOptions"
              :settings="select2SettingsLabel"
              required
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" class="mb-3">
          <b-form-group>
            <template #label>
              Description <span class="text-danger">*</span>
            </template>
            <quill-editor v-model="form.content" id="content" :options="snowOption" />
          </b-form-group>
        </b-col>

        <b-col class="d-flex justify-content-end">
          <b-button type="button" class="mr-1" variant="light" @click="cancel">
            Cancel
          </b-button>
          <b-button type="submit" :disabled="isLoading" variant="primary">
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'
import Select2 from 'v-select2-component'
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
    quillEditor,
    Select2,
  },
  data() {
    return {
      isLoading: false,
      snowOption: { theme: 'snow' },
      form: {
        title: '',
        youtubeLink: '',
        content: '',
        label_name: [],
      },
      select2SettingsLabel: {
        placeholder: 'choose labels...',
        allowClear: true,
        multiple: true,
        ajax: null,
      },
      labelNameOptions: [],
      token: '',
    }
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
    this.select2SettingsLabel = {
      placeholder: 'choose labels...',
      allowClear: true,
      multiple: true,
      ajax: {
        url: `${process.env.VUE_APP_API_HELPER_URL}/podcast/label`,
        dataType: 'json',
        delay: 250,
        headers: {
          'Client-Device': 'browser',
          Authorization: this.token,
        },
        data: (params) => {
          const page = params.page || 1;
          return {
            page: page,
            limit: 10,
            label: params.term || '',
          };
        },
        processResults: (data, params) => {
          params.page = params.page || 1;

          const data0 = data?.data?.[0]?.records || [];
          const data1 = data?.data?.[1]?.records || [];

          const results = [...data0, ...data1]
            .filter((item) => item.label?.trim())
            .map((item) => ({
              id: item.label,
              text: item.label,
            }));

          const hasMore = results.length >= 10;

          return {
            results,
            pagination: { more: hasMore }
          };
        },
        cache: true
      }
    };


  },
  methods: {
    cancel() {
      this.$router.back()
    },

    addPodcast(event) {
      event.preventDefault()
      this.isLoading = true

      const payload = {
        title: this.form.title,
        youtube_link: this.form.youtubeLink,
        label: this.form.label_name.join(','),
        description: this.form.content,
        createdby: 'admin',
      }
      this.$http
        .post(`${process.env.VUE_APP_API_HELPER_URL}/podcast`, payload, {
          headers: {
            'Client-Device': 'browser',
            Authorization: `${this.token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(() => {
          this.$notif('Success', 'Podcast successfully created', 'success')
          this.$router.push({ name: 'admin-podcast' })
        })
        .catch((err) => {
          const msg = err.response?.data?.message || err.message || 'Unknown error'
          this.$notif('Error', msg, 'error')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
.select2-container b[role='presentation'] {
  display: none !important;
}
</style>

<style scoped>
.ql-container {
  height: 200px;
}
</style>
